import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import RefreshIcon from '@mui/icons-material/Refresh';
import toast from "react-hot-toast";
import CircularProgress from '@mui/material/CircularProgress';

const NetworkOff: React.FC = () => {
    const [loading, setLoading] = useState(false);

    const handleRetry = () => {
        setLoading(true);
        setTimeout(() => {
            if (navigator.onLine) {
                window.location.reload();
            } else {
                toast.error("Still offline. Please check your network connection.");
                setLoading(false);
            }
        }, 1500); // Delay to show loader
    };

  return (
    <div className="min-h-screen bg-secondary-50 dark:bg-secondary-900 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="max-w-md w-full text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, duration: 0.3 }}
          className="mb-8"
        >
          <div className='-mt-40'><WifiOffIcon sx={{ fontSize: 140, color: '#0284c7'}}/></div>
           <h2 className="text-2xl font-semibold text-secondary-900 dark:text-white mb-2">
            Oops!
          </h2>
          
          <p className="text-secondary-600 dark:text-secondary-400">
            No internet connection found check your connection
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.3 }}
          className="space-y-4"
        >
          {
            loading ? (
                <button
                    disabled
                    className="inline-flex items-center justify-center w-full px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200 gap-2 opacity-50 cursor-not-allowed"
                >
                    <CircularProgress size={18} sx={{ color: "white" }}/>
                    Try Again
                </button>
            ):(
                <button
                    onClick={handleRetry}
                    className="inline-flex items-center justify-center w-full px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200 gap-2"
                >
                    <RefreshIcon className="h-5 w-5" />
                    Try Again
                </button>
            )
          }         
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NetworkOff; 